export default __webpack_public_path__ + "static/media/Anca_Bogdana_Rusu_AHV_In_Moms_We_Trust.86113ef2.jpg";